<template>
    <div class="onboarding-quicktrial-mobile">
        <div class="onboarding-quicktrial-mobile__header">
            <div class="onboarding-quicktrial-mobile__header-logo">
                <CompassLogo type="logo" :width="170" />
            </div>
        </div>

        <div class="onboarding-quicktrial-mobile__content">
            <div class="onboarding-quicktrial-mobile__content-illustration">
                <img src="/ressources/logged/img/onboarding/onboarding-trial-mobile.png" />
            </div>

            <p
                :class="[
                    'onboarding-quicktrial-mobile__content-title',
                    isDesktop
                        ? 'typographies-display-small'
                        : 'typographies-paragraph-large-bold',
                ]"
                v-html="
                    $t.__('pages.onboarding.trial.OnboardingQuicktrialMobile.description', {
                        br: '</br>',
                    })
                "
            />

            <CompassButton
                :label="$t.__('pages.onboarding.trial.OnboardingQuicktrialMobile.button')"
                leftIcon="richeditor-video"
                :size="isDesktop ? 'large' : 'medium'"
                @click="openRedirectPage"
            />
        </div>
    </div>
</template>

<script>
import { isDesktop } from 'utils/global';

export default {
    data() {
        return {
            isDesktop: isDesktop(),
        };
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.isDesktop = isDesktop();
        });
    },
    methods: {
        openRedirectPage() {
            window.open('https://go.sellsy.com/landing-video/demo-prospection-vente', '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
.onboarding-quicktrial-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-6);
    padding: var(--spacing-6) var(--spacing-4);
    margin: -32px -32px 0 !important;
    min-height: 100vh;

    &__header {
        @media screen and (min-width: 1024px) {
            align-self: flex-start;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--spacing-5);

        @media screen and (min-width: 1024px) {
            margin: auto;
        }

        &-illustration img {
            width: 100%;
            max-width: 315px;
            margin: 0 auto;

            @media screen and (min-width: 1024px) {
                max-width: 500px;
            }
        }

        &-title {
            margin: 0;

            @media screen and (min-width: 1024px) {
                text-align: center;
            }
        }
    }
}
</style>

<style lang="scss">
.page-onboarding-trial-mobile #sellsy_app,
#sellsy_app:has(.onboarding-quicktrial-mobile) {
    min-width: auto !important;
    background-color: var(--colors-common-background-app) !important;
}
</style>
